import {useState} from "react";

const ProductList = ({productList, selectedProductTab, setSelectedProductTab}) => {
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const currentIndex = productList.findIndex(item => item.id === selectedProductTab);

  const handlePrev = () => {
    if (productList.length <= 1) return;

    const newIndex = currentIndex > 0 ? currentIndex - 1 : productList.length - 1;
    setSelectedProductTab(productList[newIndex].id);
  };

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
    setTouchEnd(null);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const minSwipeDistance = 50; // 최소 스와이프 거리

    if (distance > minSwipeDistance) {
      handleNext();
    } else if (distance < -minSwipeDistance) {
      handlePrev();
    }
  };

  // 다음 항목으로 이동
  const handleNext = () => {
    if (productList.length <= 1) return;

    const newIndex = currentIndex < productList.length - 1 ? currentIndex + 1 : 0;
    setSelectedProductTab(productList[newIndex].id);
  };

  return (

      <div className="design-history-product-list-container">
        <div className="nav-arrow prev-arrow" onClick={handlePrev}>
          &lt;
        </div>
        <div
          className={"design-history-product-list"}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {productList?.map(item => {
            const isVisible = selectedProductTab === item.id;

            return (
              <div
                key={item.id}
                className={`product ${selectedProductTab === item.id ? "current" : ""} ${!isVisible ? "hidden" : ""}`}
                onClick={() => setSelectedProductTab(item.id)}
              >
                {`${item.displayTitle} ${item.displaySubtitle}`}
              </div>
            );
          })}
        </div>
        <div className="nav-arrow next-arrow" onClick={handleNext}>
          &gt;
        </div>
      </div>
  )
}
export default ProductList;
